/**
 * @overview Shared services for Sign Up flow and constants for Desktop and Mobile Edition.
 * @todo Expose functions and data on an single object - Vi
 */
angular.module('dpw.services')
    .factory('signUpDispatch', function () {
        var statusActions = {
            Success: 'onSuccess',
            Disabled: 'onDisabled',
            Not_A_Developer: 'onNotADeveloper',
            Failed: 'onFailed',
            Belong_To_Carrier_Brand: 'onPartnerBrand',
            Need_Upgrade_Service_Plan: 'onTierNotSupported',
            Standard_Tier_Mrr_100: 'onStandardTierMrr100'
        };

        /**
         * @param {String} status
         * @param {Object} actions
         */
        return function (status, actions) {
            var actionName = statusActions[status];
            angular.isFunction(actions[actionName]) && actions[actionName]();
        };
    })
    .factory('questionnaire', function () {
        return {
            // TODO: Move questionFormElements to here - Vi
            formElements: {},
            /**
             * Check that if selected cases contained un-support cases.
             * @param {Array} casesNotSupported
             * @param {Array} selectedCases
             * @return {Boolean}
             */
            checkUseCases: function (casesNotSupported, selectedCases) {
                return casesNotSupported.some(function (useCase) {
                    return selectedCases.indexOf(useCase) > -1;
                });
            },

            /**
             * Replace #otherCaseName to their exactly value.
             * @param {Array} selectedCases
             * @param {String} otherCaseName
             */
            handleOtherUseCase: function (selectedCases, otherCaseName) {
                var otherItemIndex = selectedCases.indexOf(otherCaseName);
                if (otherItemIndex > -1) {
                    selectedCases.splice(otherItemIndex, 1);
                }
            }
        };
    })
    .constant('questionFormElements', {
        appName: {
            required: true,
            name: 'applicationName',
            label: 'Application Name'
        },
        appDesc: {
            required: true,
            name: 'applicationDescription',
            label: 'Application Description'
        },
        appTypes: {
            required: true,
            name: 'applicationTypes',
            label: 'Application Type',
            items: [
                {value: 'Server', label: 'Server'},
                {value: 'Mobile', label: 'Mobile'},
                {value: 'Desktop', label: 'Desktop'},
                {value: 'Browser', label: 'Browser'}
            ]
        },
        useCases: {
            required: true,
            name: 'useCases',
            label: 'Use Cases',
            items: [
                {value: 'Send / Receive SMS', label: 'Send / Receive SMS'},
                {value: 'Call Recording Retrieval', label: 'Call Recording Retrieval'},
                {value: 'Send / Receive Fax', label: 'Send / Receive Fax'},
                {value: 'SMS Marketing / Demand Campaigns', label: 'SMS Marketing / Demand Campaigns'},
                {value: 'Click to Dial', label: 'Click to Dial'},
                {value: 'Fax Marketing / Demand Campaigns', label: 'Fax Marketing / Demand Campaigns'},
                {value: 'Inbound Call Screen Pop', label: 'Inbound Call Screen Pop'},
                {value: 'Automated Dialing from List', label: 'Automated Dialing from List'},
                {value: 'Call Log Retrieval', label: 'Call Log Retrieval'},
                {value: 'Other', label: 'Other:'}
            ],
            other: {
                name: 'Other'
            }
        },
        mainNumber: {
            required: true,
            name: 'mainNumber',
            label: 'RingCentral Main Company Phone Number'
        },
        extension: {
            required: false,
            name: 'extension',
            label: 'RingCentral Extension'
        },
        username: {
            required: true,
            name: 'userName',
            label: 'Your Name'
        },
        email: {
            required: true,
            name: 'email',
            label: 'Your Email Address'
        },
        companyName: {
            required: true,
            name: 'company',
            label: 'Company Name'
        },
        casesNotSupported: [
            'Call Recording Retrieval',
            'SMS Marketing / Demand Campaigns',
            'Fax Marketing / Demand Campaigns',
            'Automated Dialing from List'
        ]
    });